import Request from "../handleRequest/Request";
function toQueryStrings(params) {
    return "?" + Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join('&')
}
export default {

    addOne(data) {
        return Request.post("api/model/v1/shipping/cost", data)
            .then((res) => {
                return res;
            })
            .catch((err) => {
                throw err;
            });
    },

    deleteOne(data) {
        return Request.delete("api/model/v1/shipping/cost", toQueryStrings(data))
            .then((res) => {
                return res;
            })
            .catch((err) => {
                throw err;
            });
    },

    //   getShippingCost(data) {
    //     return Request.patch("api/model/v1/shipping/cost", data)
    //       .then((res) => {
    //         return res;
    //       })
    //       .catch((err) => {
    //         throw err;
    //       });
    //   },
};
